import { useMutation } from '@apollo/client';
import { deleteProgramMutation } from '../queries';

export const useDeleteProgram = () => {
  return useMutation(deleteProgramMutation, {
    refetchQueries: ['fetchEditPrograms'],
  });
};
